<template>
    <div>
        <Navbar class="nav" :showInfoButton="state.showInfoButton" @toggleInfo="toggleInfo" />
        <div class="space-maker"></div>
        <ChooseDeck :showInfo="state.showInfo" @chosenDeck="saveChosenDeck" v-if="state.phase==1" />
        <Phase1 :showInfo="state.showInfo" @phasecomplete="changePhase" v-if="state.phase==2" :chosenDeck="state.chosenDeck" />
        <Phase2 :showInfo="state.showInfo" @phasecomplete="changePhase" v-if="state.phase==3"/>
        <Summary @phasecomplete="changePhase" v-if="state.phase==4"/>
        <Phase3 @restartFromBeginning="restartFromBeginning" @restartFromPhaseTwo="restartFromPhaseTwo" v-if="state.phase==5"/>
    </div>
</template>

<script>
import Navbar from '../components/Navbar.vue';
import ChooseDeck from '../components/ChooseDeck.vue';
import Phase1 from '../components/Phase1.vue';
import Phase2 from '../components/Phase2.vue';
import Phase3 from '../components/Phase3.vue';
import {reactive} from 'vue';
import Summary from '../components/Summary.vue';

export default {
    name: 'Conversation',
    components:{
        ChooseDeck,
        Phase1,
        Phase2,
        Phase3,
        Navbar,
        Summary
    },
    setup() {

        /**
         * When a Phase component emits "phasecomplete", changePhase function is called
         * and a state.phase is increased. It's a reactive constant so the template
         * gets the information immediately.
         */
        const state = reactive({ phase: 1, chosenDeck: null, showInfoButton: true, showInfo: true });
        const changePhase = () => {
            state.phase++
            if (state.phase === 4)
                state.showInfoButton = false;
        };

        const saveChosenDeck = (index) => {
            state.chosenDeck = index;
            changePhase();
        }

        const restartFromBeginning = () => {
            state.phase = 1;
            state.showInfoButton = true;
        }

        const restartFromPhaseTwo = () => {
            state.phase = 2;
        }

        const toggleInfo = (showInfo) => {
            state.showInfo = showInfo;
        }

        return { state, changePhase, saveChosenDeck, restartFromBeginning, restartFromPhaseTwo, toggleInfo };
    }
}
</script>

<style>
ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: var(--link_color);
}

/*
  Button animation which is used mostly in conversation.
  Fades to slithly darker yellow in 350 millisecond.
*/
button {
    transition: background-color 350ms ease-in-out;
    margin-left: 10px;
    margin-right: 10px;
    cursor: pointer;
}

button:hover, .btn:active {
    background-color: #d9dc6f;
}

.space-maker {
    height: 3.7vh;
}

.global-hover {
    transition: 250ms background-color ease;
}

.global-hover:hover {
    border-radius: 3px;
    cursor: pointer;
    background-color: var(--btn_hover);
}
</style>
